import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { fmtDate, fmtTRY } from "../../lib/format";

const STATUS_BADGE = {
  REQUESTED: "bg-amber-500/15 text-amber-400",
  APPROVED: "bg-blue-500/15 text-blue-400",
  REJECTED: "bg-rose-500/15 text-rose-400",
  IN_TRANSIT: "bg-indigo-500/15 text-indigo-400",
  RECEIVED: "bg-teal-500/15 text-teal-400",
  COMPLETED: "bg-emerald-500/15 text-emerald-400",
};
const STATUS_LABEL = {
  REQUESTED: "Talep Alındı", APPROVED: "Onaylandı", REJECTED: "Reddedildi",
  IN_TRANSIT: "Yolda", RECEIVED: "Teslim Alındı", COMPLETED: "Tamamlandı",
};
const ACTIONS = {
  REQUESTED: [["approve", "Onayla"], ["reject", "Reddet"]],
  APPROVED: [["in_transit", "Kargoya Alındı"], ["reject", "Reddet"]],
  IN_TRANSIT: [["received", "Teslim Alındı"]],
  RECEIVED: [["complete", "Tamamla + İade Et"]],
};

export default function ReturnsPage() {
  const [items, setItems] = useState(null);
  const [filter, setFilter] = useState("");

  const load = () => {
    const params = filter ? `?status=${filter}` : "";
    api.get(`/admin/returns${params}`).then(({ data }) => setItems(data)).catch((e) => toast.error(errMsg(e)));
  };
  useEffect(load, [filter]);

  const act = async (returnId, action) => {
    const label = { approve: "onaylansın", reject: "reddedilsin", in_transit: "kargoda işaretlensin", received: "teslim alındı", complete: "tamamlanıp iade başlatılsın" }[action];
    if (!window.confirm(`İade talebi ${label} mı?`)) return;
    try {
      await api.put(`/admin/returns/${returnId}`, { action });
      toast.success("İade talebi güncellendi");
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="space-y-5" data-testid="admin-returns">
      <h1 className="font-display font-extrabold text-2xl text-white">İade Talepleri</h1>
      <div className="flex gap-2 flex-wrap">
        {[["", "Tümü"], ["REQUESTED", "Bekleyen"], ["APPROVED", "Onaylı"], ["IN_TRANSIT", "Yolda"], ["RECEIVED", "Teslim Alındı"], ["COMPLETED", "Tamamlandı"], ["REJECTED", "Reddedildi"]].map(([v, l]) => (
          <button key={v} onClick={() => setFilter(v)}
            className={`h-9 px-4 rounded-xl text-xs font-semibold transition-colors ${filter === v ? "bg-blue-600 text-white" : "bg-[#181B20] text-neutral-400 border border-[#272B33] hover:text-white"}`}
            data-testid={`return-filter-${v || "all"}`}>{l}</button>
        ))}
      </div>

      <div className="space-y-3">
        {items?.map((r) => (
          <div key={r.return_id} className="bg-[#181B20] border border-[#272B33] rounded-2xl p-5 flex flex-wrap items-center gap-4" data-testid={`return-row-${r.return_id}`}>
            <div className="flex-1 min-w-[220px]">
              <p className="font-mono-ed text-white font-bold">{r.order_number}</p>
              <p className="text-xs text-neutral-500 mt-0.5">{r.order?.contact?.name} · {fmtTRY(r.order?.total)} · {fmtDate(r.created_at)}</p>
              <p className="text-sm text-neutral-300 mt-2"><span className="text-neutral-500">Neden:</span> {r.reason}{r.description ? ` — ${r.description}` : ""}</p>
              {r.refund_amount != null && <p className="text-xs text-emerald-400 mt-1">İade tutarı: {fmtTRY(r.refund_amount)}</p>}
            </div>
            <span className={`text-[11px] font-bold px-3 py-1.5 rounded-full ${STATUS_BADGE[r.status]}`} data-testid="return-status-badge">{STATUS_LABEL[r.status]}</span>
            <div className="flex gap-2">
              {(ACTIONS[r.status] || []).map(([action, label]) => (
                <button key={action} onClick={() => act(r.return_id, action)}
                  className={`h-9 px-4 rounded-xl text-xs font-semibold ${action === "reject" ? "bg-rose-600/15 text-rose-400 hover:bg-rose-600/25" : "bg-blue-600/15 text-blue-400 hover:bg-blue-600/25"}`}
                  data-testid={`return-${action}-btn`}>{label}</button>
              ))}
            </div>
          </div>
        ))}
        {items?.length === 0 && <p className="text-center text-neutral-500 text-sm py-16 bg-[#181B20] border border-[#272B33] rounded-2xl">İade talebi yok</p>}
      </div>
    </div>
  );
}
